/**
 * recipe-step-anchors.js
 *
 * Adds anchor IDs to recipe step headings so they can be linked/jumped to, 
 * e.g.  …/recipe-handle#recipe-step-3
 *
 * The recipe rich text renders each step as an <h6>Step #N</h6> inside a
 * container with the class `.metafield-rich_text_field`. This script finds
 * those <h6> elements and sets id="recipe-step-N".
 *
 * The step number N is read from the heading text ("Step #3" -> 3) so it stays
 * correct even if a heading is skipped; it falls back to the running position
 * if no number is present in the text.
 */
(function () {
  function slugifyStep(h6, fallbackIndex) {
    var text = (h6.textContent || '').trim();          // e.g. "Step #3" (leading \n is collapsed by the browser)
    var match = text.match(/step\s*#?\s*(\d+)/i);       // pull the number out of the heading text
    return match ? match[1] : String(fallbackIndex);
  }

  function applyAnchors() {
    var containers = document.querySelectorAll('.metafield-rich_text_field');

    containers.forEach(function (container) {
      var headings = container.querySelectorAll('h6');
      var step = 0;

      headings.forEach(function (h6) {
        step += 1;
        var id = 'recipe-step-' + slugifyStep(h6, step);

        // Don't clobber an id that's already set to something else.
        if (!h6.id) {
          h6.id = id;
        }
      });
    });

    // If the page was opened with a #recipe-step-N hash, the target didn't exist
    // when the browser first tried to jump to it — re-trigger the scroll now.
    if (location.hash) {
      var target = document.getElementById(location.hash.slice(1));
      if (target) {
        target.scrollIntoView();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAnchors);
  } else {
    applyAnchors();
  }

  // Expose for manual re-runs after dynamic/AJAX content loads (e.g. quick views).
  window.applyRecipeStepAnchors = applyAnchors;
})();
